class FetchAiCostFilterOptions {
	constructor(public readonly accountId: number) {
		Object.freeze(this);
	}
}

export default FetchAiCostFilterOptions;
